import {call, put, takeEvery} from "redux-saga/effects"
import { toast } from 'react-toastify';
import store from 'redux/store';
import { GET_SERVICECITY_FAILED, GET_SERVICECITY_REQUESTED, GET_SERVICECITY_SUCCESS, GET_SERVICEREGION_FAILED, GET_SERVICEREGION_REQUESTED, GET_SERVICEREGION_SUCCESS, GET_ADDSERVICEREGION_FAILED, GET_ADDSERVICEREGION_REQUESTED, GET_ADDSERVICEREGION_SUCCESS, GET_SUBVENDORREGION_FAILED, GET_SUBVENDORREGION_REQUESTED, GET_SUBVENDORREGION_SUCCESS, GET_ADDSUBVENDORREGION_FAILED, GET_ADDSUBVENDORREGION_REQUESTED, GET_ADDSUBVENDORREGION_SUCCESS } from "resources/actionTypes"
import { serviceCityApi, serviceRegionApi, addServiceRegionApi, subVendorRegionApi, addsubVendorRegionApi } from "services/ServiceCityService"
import { getSubVendorRegion } from "redux/actions/UserServiceCity";
import { onLoaderTrigger } from "redux/actions/CommonAction";

function* fetchServiceCity(action) {
  try {
    const payload = action.payload || {}
    const userServiceCity = yield call(serviceCityApi,payload);
    yield put({ type: GET_SERVICECITY_SUCCESS, userServiceCity: userServiceCity });
  } catch (e) {
    yield put({ type: GET_SERVICECITY_FAILED, message: e.message });
    toast.error(e.message || 'Get Service City Failed')
  }
}

export function* serviceCitySaga() {
  yield takeEvery(GET_SERVICECITY_REQUESTED, fetchServiceCity);
}

function* fetchServiceRegion(action) {
  try {
    const payload = action.payload || {}
    const userServiceRegion = yield call(serviceRegionApi,payload);
    yield put({ type: GET_SERVICEREGION_SUCCESS, userServiceRegion: userServiceRegion });
  } catch (e) {
    yield put({ type: GET_SERVICEREGION_FAILED, message: e.message });
    toast.error(e.message || 'Get Service Region Failed')
  }
}

export function* serviceRegionSaga() {
  yield takeEvery(GET_SERVICEREGION_REQUESTED, fetchServiceRegion);
}

function* fetchAddServiceRegion(action) {
  const payload = action.payload || {};
  store.dispatch(onLoaderTrigger(true));
  const userAddServiceRegion = yield call(
    addServiceRegionApi,
    payload.userAddServiceRegion
  );
  if (userAddServiceRegion.success) {
    yield put({
      type: GET_ADDSERVICEREGION_SUCCESS,
      userAddServiceRegion: userAddServiceRegion,
    });
    store.dispatch(onLoaderTrigger(false));
   
  } else {
    store.dispatch(onLoaderTrigger(false));
    yield put({
      type: GET_ADDSERVICEREGION_FAILED,
      message: userAddServiceRegion.message,
    });
      toast.error(userAddServiceRegion.message || 'Service Failed ');
  }
}

export function* addServiceRegionSaga() {
  yield takeEvery(
    GET_ADDSERVICEREGION_REQUESTED,
    fetchAddServiceRegion
  );
}

function* fetchSubVendorRegion(action) {
  try {
    const payload = action.payload || {}
    const userSubVendorRegion = yield call(subVendorRegionApi,payload);
    yield put({ type: GET_SUBVENDORREGION_SUCCESS, userSubVendorRegion: userSubVendorRegion });
  } catch (e) {
    yield put({ type: GET_SUBVENDORREGION_FAILED, message: e.message });
    toast.error(e.message || 'Get SubVendor Region Failed')
  }
}

export function* serviceSubVendorRegionSaga() {
  yield takeEvery(GET_SUBVENDORREGION_REQUESTED, fetchSubVendorRegion);
}


function* fetchAddSubVendorRegion(action) {
  const payload = action.payload || {};
  store.dispatch(onLoaderTrigger(true));
  const userAddSubVendorRegion = yield call(
    addsubVendorRegionApi,
    payload.userAddSubVendorRegion
  );
  if (userAddSubVendorRegion.success) {
    yield put({
      type: GET_ADDSUBVENDORREGION_SUCCESS,
      userAddSubVendorRegion: userAddSubVendorRegion,
    });
    toast.success(userAddSubVendorRegion.message)
    store.dispatch(onLoaderTrigger(false));
    if(payload?.userAddSubVendorRegion?.subvendorId){
      store.dispatch(getSubVendorRegion({submitterId:payload?.userAddSubVendorRegion?.subvendorId}))
    }
   
  } else {
    store.dispatch(onLoaderTrigger(false));
    yield put({
      type: GET_ADDSUBVENDORREGION_FAILED,
      message: userAddSubVendorRegion.message,
    });
      toast.error(userAddSubVendorRegion.message || 'Service Failed ');
  }
}

export function* addSubVendorRegionSaga() {
  yield takeEvery(
    GET_ADDSUBVENDORREGION_REQUESTED,
    fetchAddSubVendorRegion
  );
}